
import React, { useEffect } from 'react';
import Dpu_alumni from '../landing-page/components/dpu_alumni/Dpu_alumni';
import Hiring_Partners from '../landing-page/components/hiring_partners/Hiring_Partners';
import Confirmation_Message from './confirmation_message/Confirmation_Message'
import './thank-you.css'

export default function ThankYouPage() {

useEffect(() => {
  if (typeof window !== "undefined" && (window as any).gtag) {
    
    // Old conversion
    // (window as any).gtag("event", "conversion", {
    //   send_to: "AW-16713947906/arkCCMa4iusbEIK26qE-",
    //   value: 1.0,
    //   currency: "INR",
    // });

    // New conversion
    (window as any).gtag("event", "conversion", {
      send_to: "AW-16713947906/teNiCKCo1_sbEIK26qE-",
      value: 1.0,
      currency: "INR",
    });

  }
}, []);

  return (
    <div className='ThankYouPage'>
      <Confirmation_Message />
      <Dpu_alumni />
      <Hiring_Partners/>
    </div>
  );
}